import { Box } from "@mui/material";
import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { type FlatSwitchOption, SystemFlatSwitch } from "../../../../../components/UIToolkit/Clickable/SystemFlatSwitch";
import { HrisTimeOffAlignment } from "./HrisTimeOffAlignment";
import { TimeOffTypeMappingGrid } from "./TimeOffTypeMappingGrid";

enum TimeOffView {
	RawTableConfig = "rawTableConfig",
	PrettyMapping = "prettyMapping",
}

/**
 * Wrapper around the Time Off Types tab that adds a Raw Table / Pretty Mapping toggle, mirroring
 * the Roles & Jobs tab. Defaults to Pretty Mapping (the new two-pane view).
 */
export const TimeOffTabContent: FC = () => {
	const { t } = useTranslation();
	const [view, setView] = useState<TimeOffView>(TimeOffView.PrettyMapping);

	const options: FlatSwitchOption<TimeOffView>[] = [
		{ label: t("hris.mapping.view.pretty"), value: TimeOffView.PrettyMapping, "data-testid": "hris-mapping-time-off-view-pretty" },
		{ label: t("hris.mapping.view.rawTable"), value: TimeOffView.RawTableConfig, "data-testid": "hris-mapping-time-off-view-raw" },
	];

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%" }} data-testid="hris-mapping-time-off-tab">
			<Box>
				<SystemFlatSwitch<TimeOffView>
					options={options}
					activeIndexOrValue={view}
					onSwitch={(option) => setView(option.value)}
					rootMaxWidth={360}
					data-testid="hris-mapping-time-off-view-switch"
				/>
			</Box>
			<Box sx={{ flex: 1, minHeight: 0 }}>{view === TimeOffView.PrettyMapping ? <HrisTimeOffAlignment /> : <TimeOffTypeMappingGrid />}</Box>
		</Box>
	);
};
